exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-state-design-modal .state-design-modal-header{margin-bottom:.375rem}.fts-state-design-modal .state-design-input-wrapper{min-width:0;flex:1}.fts-state-design-modal .state-design-input-wrapper>input{max-width:100%}", ""]);

// exports
